<template>

	<div class="container main-content example-drag">
		<div class="row">
			<div class="col-12 col-sm-5 offset-sm-1">
				<template v-if="showMobileInput">
				<div class="row mb-5">
					<div class="col-12 text-center mt-5">

						<h4 class="dark-highlight mb-5">Enter your mobile number</h4>

						<input-phone v-model="mobileNumber" 
									placeholder="Mobile"
									:isProcessing="false"
									inputclass="mobile"
									:fiatCurrency="fiatCurrency"
									:phoneinfo="phoneinfo"
									:errorinfo="errors.mobile">
								</input-phone>

						<small class="error" v-if="hasError">{{ errorMsg }}</small>

					</div>
				</div>
				<div class="row">
					<div class="col-12 text-center">
						<a href="#" id="address-input-next" class="btn next-btn" v-on:click.prevent="validateMobile">NEXT</a>
					</div>
				</div>
				</template>
				<template v-else>

					<div class="row" v-if="uploadComplete">
						<div class="col-12 text-center">
							<h3 class="upload-success mb-2">Thank you</h3>
							<p class=" mb-5">Your document have been received.  We will contact you shortly.</p>
						</div>
					</div>

					<div class="row">
						<div class="col-12 text-center">
							<small class="error" v-if="hasError">{{ errorMsg }}</small>
						</div>
					</div>

					<div class="uploaded-files" v-if="files.length" :key="componentKey">

						<div v-for="file in files" :key="file.id" class="form-group">
							
							<div class="row pt-0 pb-4">

								<div class="col-12 text-center text-left-md col-md-3 word-wrap mb-3 mb-md-0">
									<img v-if="file.thumb" :src="file.thumb" width="40" height="auto" />
									<span v-else>No Image</span>
								</div>
								
								<div class="col-12 col-md-6 mb-3 mb-md-0">
									<select :ref="file.id" :disabled="isUploading || file.done" class="form-control form-control-upload" @change="onChange($event)">
										<option v-for="(type, index) in docType" :key="index" :value="index" :disabled="index == '' ? true : false" :selected="checkSelectedValue(file.id, index)">{{ type }}</option>
									</select>
								</div>

								<div class="col-12 col-md-3 text-right-md text-left">
									<a href="#" title="Remove" class="btn btn-rounded btn-remove" v-if="!isUploading && !file.done" @click.prevent="remove(file)"><i class="fas fa-times"></i></a>

									<strong>	
										<span v-if="file.error" class="error">{{file.error}}</span>
										<span v-else-if="file.done" class="upload-success"><i class="fas fa-check"></i> success</span>
										<span v-else-if="isUploading && !file.done"><i class="fas fa-circle-notch fa-spin"></i> uploading</span>
									</strong>

								</div>
							</div>
							
						</div>
					</div>
					<div class="file-upload-box" v-else>
						<div class="text-center p-3">
							<h4 class="dark-highlight mb-4">Drop files anywhere to upload</h4>
							<img class="doc-upload-icon" src="./../assets/img/doc_upload_icon.png">
						</div>
					</div>

					<div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
						<h3>Drop files to upload</h3>
					</div>

					<div class="text-center row">
						
						<div class="col-12 col-md-6 pr-0 pl-0 mt-3">
							<file-upload
								class="btn btn-rounded btn-rounded-primary btn-upload mr-2"
								:custom-action="startAsyncUpload"
								:multiple="true"
								:drop="true"
								:drop-directory="true"
								:size="maxFileSize"
								:disabled="isUploading"
								v-model="files"
								@input-filter="inputFilter"
								@input-file="inputFile"
								ref="upload">
								<i class="fa fa-plus"></i>&nbsp;
								Select files
							</file-upload>
							
						</div>
						<div class="col-12 col-md-6 pr-0 pl-0 mt-3">
							<template v-if="uploadComplete || isUploading">
								<a href="#" class="btn btn-rounded btn-upload disabled" v-on:click.prevent="noop">Start Upload</a>
							</template>
							<template v-else>
								<a href="#" class="btn btn-rounded btn-rounded-primary btn-upload btn-upload-start" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="validateForm">Start Upload</a>
							</template>
						
						</div>

						<div class="col-12 mt-4">
							<small class="col-6 text-center text-secondary">
								<a v-if="!uploadComplete" href="#" @click.prevent="back">Back</a>
								<a v-else href="#" @click.prevent="back">Start over</a>
							</small>
						</div>
						
					</div>

				</template>
			</div>
			<div class="col-12 pt-5 pt-sm-0 offset-sm-1 col-sm-5 info-text" style="font-size: 0.8rem">
				<h5 class="mb-4">Identity Verification</h5>
				<p class="mb-3">Please provide a photo (front and back) of a government issued photo identification along with an additional document providing proof of address.</p>
				
				<h5 class="mb-2">List of Government Issued Photo ID</h5>
				<ul>
					<li>Drivers License issued in {{ getCountry }}</li>
					<li>Provincial or territorial identity cards</li>
					<li>{{ getNationality }} Passport</li>
					<li>Certificate of {{ getNationality }} Citizenship (with photo)</li>
					<li>Permanent Resident Card</li>
					<li>Secure Certificate of Indian Status</li>
				</ul>

				<h5 class="mb-2">List of Acceptable Proof of Address Documents.</h5>
				<p>Document must be no older than 3 months.</p>
				<ul>
					<li>Electricity, Gas, Landline, or Hydro Bill</li>
					<li>Bank or Credit Card Statement</li>
				</ul>

				<h5 class="mb-2">Corporation</h5>
				<ul>
					<li>Certificate of corporate status</li>
					<li>Certificate of Incorporation</li>
					<li>Letter or notice of assessment from a municipal, provincial, territorial or federal government</li>
				</ul>

				<h5 class="mb-2">Entity other than a corporation</h5>
				<ul>
					<li>A partnership agreement with your name as one of the directors</li>
					<li>Articles of association</li>
					<li>Letter or notice of assessment from a municipal, provincial, territorial or federal government</li>
				</ul>

			</div>
		</div>
		
	</div>

</template>

<script>
/* eslint-disable */
import { ErrorsContainer, BuyerInfo } from './../helpers/utils.js'
import { eventBus } from './../main'
import { AsYouType, parseNumber, formatNumber, isValidNumber } from 'libphonenumber-js'

export default {
	data() {
		return {
			files: [],
			in_buyerInfo: new BuyerInfo(),
			errors: new ErrorsContainer(),
			hasError: false,
			fiatCurrency: 'CAD',
			errorMsg: '',
			currentFile: null,
			country: 'CA',
			mobileNumber: '',
			phoneinfo: {},
			showMobileInput: true,
			componentKey: 0,
			isUploading: false,
			uploadComplete: false,
			maxFileSize: 4900000,
			selectValues: [],
			docType: {
				""					: "Select document type",
				"DRIVERSLICENSE" 	: "Driver's License",
				"PASSPORT" 			: "Canadian Passport",
				"GOVERNMENTID" 		: "Canadian Citizenship",
				"GOVERNMENTID" 		: "Canadian Permanent Resident Card",
				"BANKSTATEMENT" 	: "Bank Statement",
				"BANKSTATEMENT" 	: "Credit Card Statement",
				"BILLPAYMENT" 		: "Bill Payment",
				"SELFIE" 			: "Selfie with ID",
				"OTHER" 			: "Other"
			}
		};
	},
	created(){
		eventBus.$on('nextScreen', this.onEnterPress);
		
		if(this.$route.params.country != undefined){
			this.country = this.$route.params.country.toUpperCase();
		}

		if(this.country == 'AU'){
			this.fiatCurrency = 'AUD';
			this.docType = {
				""					: "Select document type",
				"DRIVERSLICENSE" 	: "Driver's License",
				"PASSPORT" 			: "Australian Passport",
				"GOVERNMENTID" 		: "Australian Citizenship",
				"GOVERNMENTID" 		: "Australian Permanent Resident Card",
				"BANKSTATEMENT" 	: "Bank Statement",
				"BANKSTATEMENT" 	: "Credit Card Statement",
				"BILLPAYMENT" 		: "Bill Payment",
				"SELFIE" 			: "Selfie with ID",
				"OTHER" 			: "Other"
			}
		}

		var errorsContainer = new ErrorsContainer();
		errorsContainer.addPropsFromModelObj(this.in_buyerInfo);
		this.errors = errorsContainer;
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.onEnterPress);
	},
	computed: {
		getNationality(){
			if(this.country == 'AU'){
				return 'Australian';
			} else {
				return 'Canadian';
			}
		},
		getCountry(){
			if(this.country == 'AU'){
				return 'Australia';
			} else {
				return 'Canada';
			}
		}
	},
	methods: {
		onInput(){
		},
		back(){
			this.hasError = false;
			this.errorMsg = '';
			this.showMobileInput = true
			this.mobileNumber = new AsYouType('CA').input(this.mobileNumber);

			if(this.uploadComplete){
				this.resetUploadFiles();
			}
		},
		onEnterPress(){
			if(this.showMobileInput){
				this.validateMobile();
			} else {
				this.validateForm();
			}
		},
		onChange(){
			this.saveSelectValues();
		},
		validateMobile(){

			this.errors.clearAll();

			// don't validate phone if debug because it doesn't like my prefilled in phone number
			if (!this.phoneinfo.isValid) {
				if(this.phoneinfo.errorMsg){
					this.errors.mobile.setError(this.phoneinfo.errorMsg);
				} else {
					this.errors.mobile.setError('Mobile must be a valid phone number');
				}
			} 

			if (this.errors.count > 0) {
				return;
			}

			this.uploadComplete = false;
			this.hasError = false;
			this.errorMsg = '';
			this.showMobileInput = false;
		},
		validateForm(){

			if(this.uploadComplete){
				this.hasError = true;
				this.errorMsg = 'Documents already uploaded.'
				return;
			}

			for(var i = 0; i < this.files.length; i++){
				if(this.$refs[this.files[i].id][0].value == ""){
					this.hasError = true;
					this.errorMsg = 'Please select a document type from the dropdown menu for each file you are uploading.'
					return;
				}
			}

			if(this.files.length == 0){
				this.hasError = true;
				this.errorMsg = 'You must upload at least 1 file.'
				return;
			}

			this.isUploading = true;
			this.$refs.upload.active = true;
		},
		async startAsyncUpload(file, component) {
			
			var result = await this.uploadFile(file);

			if(result && result.error){
				// update the list with the error
				component.update(file, {error: result.msg});
			}

			return result;
		},
		uploadFile(file) {

			let reader = new FileReader()
			let theFile = file.file;
			theFile.id = file.id;
			
			// Convert the file to base64 text
			reader.readAsDataURL(theFile)
			reader.onload = () => {

				// Make a fileInfo Object
				let fileInfo = {
					name: theFile.name,
					type: theFile.type,
					size: Math.round(theFile.size / 1000)+' kB',
					base64: reader.result,
					file: theFile,
					id: theFile.id
				}
				
				this.currentFile = fileInfo;

				return new Promise(resolve => {
					
					var formatedNumber = this.phoneinfo.countryCallingCode + '' + this.phoneinfo.areaCode + '' + this.phoneinfo.phoneNumber;

					var urlstr = this.$gstate.getUploadApiBaseURL();
					var id = this.currentFile.id;
					this.axios.post(urlstr, {
						mobileNumber : formatedNumber,
						documentType : this.$refs[file.id][0].value,
						mimeType : this.currentFile.type,
						fileName : this.currentFile.name,
						extName : this.getFileExtention(this.currentFile.name),
						encodedFile : this.cleanBase64(this.currentFile.base64),
					}, this.$gstate.getAxiosHeaders())
						.then(response => {

							this.$gstate.log("done");
							this.$gstate.log(response);
							this.$gstate.log(response.data);

							for(var i = 0; i < this.files.length; i++){
								if(this.files[i].id == id){
									this.files[i].done = true;
									this.refreshFileList();
								}
							}

							if(this.isFinishedUploading()){
								this.isUploading = false;
								this.uploadComplete = true;
								this.$toasted.success('Documents uploaded successfully!');

								this.sendEmailNotification();
							}

							resolve('success');
						})
						.catch(error => {

							this.$gstate.log("error:");
							this.$gstate.log(error.response);
							this.hasError = true;
							this.isUploading = false;

							if(error.response){
								this.errorMsg = error.response.data.error.msg;
							} else {
								this.errorMsg = "Internal Server Error.  Please contact support for further assistance."
							}

						});
					
				});

			}
		},
		isFinishedUploading(){
			for(var i = 0; i < this.files.length; i++){
				if(!this.files[i].done){
					return false;
				}
			}

			return true;
		},
		getFileExtention(filename){
			return filename.split('.').pop();
		},
		cleanBase64(data){
			return data.substr(data.indexOf(',')+1);
		},
		inputFilter(newFile, oldFile, prevent) {
			if (newFile && !oldFile) {
				// Only allow image types of files
				if (!/\.(jpeg|jpe|jpg|gif|png|pdf)$/i.test(newFile.name)) {
					this.hasError = true;
					this.errorMsg = 'Only images and PDF\'s are allowed (jpg, gif, png, pdf).';
					return prevent();
				}

				// Only allow images 4.9 MB or less
				if(newFile.size > this.maxFileSize){
					this.hasError = true;
					this.errorMsg = 'File must be less than 4.5MB.  Your file is ' + this.byteToMb(newFile.size) + 'MB.';
					return prevent();
				}

				// Create a blob field
				newFile.blob = ''
				let URL = window.URL || window.webkitURL
				if (URL && URL.createObjectURL) {
					newFile.blob = URL.createObjectURL(newFile.file)
				}

				// Thumbnails
				newFile.thumb = ''
				if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
					newFile.thumb = newFile.blob
				}
			}

		},
		inputFile(newFile, oldFile) {
			if (newFile && !oldFile) {
				// add

				// if we're adding new files after uploading some files, clear the old ones out
				if(this.uploadComplete){
					this.uploadComplete = false;
					
					// NEED to remove in reverse order.  Otherwise array for loop breaks because index shifts
					for(var i = this.files.length - 1; i >= 0; i--){
						if(this.files[i].id != newFile.id){
							this.remove(this.files[i]);
						}
					}

					this.refreshFileList();
				}

			}
			if (newFile && oldFile) {
				// update
			}
			if (!newFile && oldFile) {
				// remove
			}

			this.hasError = false;

		},
		resetUploadFiles(){
			
			// NEED to remove in reverse order.  Otherwise array for loop breaks because index shifts
			for(var i = this.files.length - 1; i >= 0; i--){
				this.remove(this.files[i]);
			}
			
			this.refreshFileList();
		},
		refreshFileList(){

			this.saveSelectValues();

			this.componentKey++;
		},
		saveSelectValues(){
			this.selectValues = [];

			// save drop down value
			for(var i = 0; i < this.files.length; i++){
				//this.remove(this.files[i]);
				if(this.$refs[this.files[i].id] !== undefined){
					this.selectValues[this.files[i].id] = this.$refs[this.files[i].id][0].value;
				}
				
			}
		},
		checkSelectedValue(id, value){
			if(this.selectValues[id] === undefined && value == ''){
				return true;
			}

			if(this.selectValues[id] == value) {
				return true;
			}

			return false;
		},
		remove(file) {
			this.$refs.upload.remove(file)
		},
		byteToMb(value){
			return (value / 1000000).toFixed(2);
		},
		sendEmailNotification(){
			fetch('https://www.enformed.io/iclkfwxu/', {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
				},
				body: JSON.stringify({
					"mobileNumber" : this.mobileNumber,
					"message" : "User has submitted their documentation.",
					"*subject" : "User has submitted their docs"
				})
			})
				.then(function(response){
					return response.json()
				})
				.then(function() {
				})
				.catch(function(){
				});
			
		}
	}
	
}

</script>